import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { tokens } from '../../theme';

export const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box sx={{
      minHeight: '100vh',
      backgroundColor: tokens.color.bg,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 4,
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '20%',
        left: '50%',
        transform: 'translateX(-50%)',
        width: 600,
        height: 600,
        borderRadius: '50%',
        background: `radial-gradient(circle, ${tokens.color.accentMuted} 0%, transparent 70%)`,
        pointerEvents: 'none',
      },
    }}>
      <RouterLink to="/" style={{ textDecoration: 'none', marginBottom: 32, position: 'relative', zIndex: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: tokens.color.textPrimary }}>
          Email<Box component="span" sx={{ color: tokens.color.accent }}>Validator</Box>
        </Typography>
      </RouterLink>
      <Container maxWidth="xs" sx={{ position: 'relative', zIndex: 1 }}>
        {children}
      </Container>
    </Box>
  );
};
